/**
 * Class on the contenteditable prompt editor. Passed to the mention picker's
 * Flyout as an ignored class name: useOnClickOutside walks the parent chain,
 * so a mousedown on a chip (a child of the editor) must not be treated as an
 * outside click — otherwise the chip-edit picker would close the instant it
 * opened.
 */
export const MENTION_EDITOR_CLASS = 'mention-prompt-editor'

/** Chip element classes, shared by the editor's DOM writer and its CSS. */
export const CHIP_CLASS = 'mention-chip'
export const CHIP_REMOVE_CLASS = 'mention-chip-remove'

/** Serialized length of a `@Image N` token (N <= 2 digits) + trailing space. */
export const MENTION_TOKEN_RESERVE = 11
